import { Container } from "../../components";

const CategoryFormContainer = ({ children, rest }) => (
  <Container.XSmall {...rest}>{children}</Container.XSmall>
);
export default CategoryFormContainer;
